const shipOperatorType = [
    { label: 'Inspection', value: 'inspection' },
    { label: 'Review', value: 'review' },
];

export default shipOperatorType;
